import { render, staticRenderFns } from "./SOV5.vue?vue&type=template&id=1052a70f&scoped=true"
import script from "./SOV5.vue?vue&type=script&lang=js"
export * from "./SOV5.vue?vue&type=script&lang=js"
import style0 from "./SOV5.vue?vue&type=style&index=0&id=1052a70f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052a70f",
  null
  
)

export default component.exports